"use client";

import { Pie, PieChart } from "recharts";
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const chartData = [
  { token: "BTC", value: 30, fill: "var(--bitcoin)" },
  { token: "AVAX", value: 23, fill: "var(--avalanche)" },
  { token: "DOGE", value: 21, fill: "var(--dogecoin)" },
  { token: "USDC", value: 12, fill: "var(--usdt)" },
  { token: "USDT", value: 14, fill: "var(--usdc)" },
];

const chartConfig = {
  value: {
    label: "Value",
  },
  btc: {
    label: "Bitcoin",
  },
  avax: {
    label: "Avalanche",
  },
  doge: {
    label: "Dogecoin",
  },
  usdc: {
    label: "USD Coin",
  },
  usdt: {
    label: "Tether",
  },
} satisfies ChartConfig;

export function AllocationChart() {
  return (
    <Card className="flex flex-col">
      <CardHeader className="px-5 py-3.5">
        <CardTitle className="text-lg">Allocations</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-1 items-center gap-4 px-1 pt-0 pb-2">
        <ChartContainer config={chartConfig} className="size-48 shrink-0">
          <PieChart className="h-full w-full">
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent hideLabel className="p-2.5" />}
            />
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="token"
              innerRadius={60}
              isAnimationActive={false}
            />
          </PieChart>
        </ChartContainer>
        <div className="w-full max-w-56 space-y-3 pr-6">
          {chartData.map(({ token, value, fill }) => (
            <div key={token} className="flex items-center gap-2">
              <span
                className="size-1.5 rounded-full"
                style={{
                  backgroundColor: fill,
                }}
              />
              <p className="text-xs font-medium text-white">{token}</p>
              <p className="text-foreground ml-auto text-xs font-medium">
                {value}%
              </p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
